/**
 * @fileoverview Barrel exports for the prose-comparer-v2 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  OptionEvaluationSchema,
  RubricHighlightSchema,
  RubricCriterionSchema,
  RUBRIC_CRITERIA,
  type Input,
  type Output,
  type OptionEvaluation,
  type RubricHighlight,
  type RubricCriterion,
} from './schema';

// Flow
export { flow, optionEvaluatorAgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
